// Contact.js
import React from 'react';

function Contact() {
  return (
    <section id="contact">
      <h1>Get in Touch</h1>
      <p>
        Contact us to learn more about our research and collaborations.
      </p>
      <p>
      k.vanaja@northeastern.edu
      </p>
    </section>
  );
}

export default Contact;